import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import { CheckContainer } from "../pages/check";
import Notfound from "../Components/Notfound";

export default function AppRouter({ pages, auth, url, page }) {
  return createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route path="/check/:epc" element={<CheckContainer />} />
        <Route path="/check" element={<Notfound />} />

        <Route path="*" element={<Notfound />} />
      </>,
    ),
  );
}
